/**
 * Backend may send `field: [from, new]` tuples; UI table expects `field: { from, to }`.
 * Returns a new map if every field can be normalized, otherwise the original value.
 */
export function normalizeBackendChanges(changes: unknown): unknown {
  if (!changes || typeof changes !== "object" || Array.isArray(changes)) {
    return changes
  }

  const obj = changes as Record<string, unknown>
  const out: Record<string, { from: unknown; to: unknown }> = {}

  for (const [key, val] of Object.entries(obj)) {
    if (
      val &&
      typeof val === "object" &&
      !Array.isArray(val) &&
      "from" in val &&
      "to" in val
    ) {
      out[key] = val as { from: unknown; to: unknown }
      continue
    }

    if (Array.isArray(val) && val.length === 2) {
      out[key] = { from: val[0], to: val[1] }
      continue
    }

    return changes
  }

  return out
}
